/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cache = { data: {} as Record<string, any> }
export function clearCache() {
  cache.data = {}
}
